module.exports = __webpack_public_path__ + "img/admin-nav.2b66fe81.png";